module.exports = __webpack_public_path__ + "img/10857_L.9460d55e.png";